module.exports = __webpack_public_path__ + "img/bjt2.c22b6db1.png";